import React from 'react';
import ServicePageTemplate from '../../components/ServicePageTemplate';
import { BarChart } from 'lucide-react';

const DataAnalytics = () => {
  const features = [
    {
      title: 'Business Intelligence',
      description: 'Comprehensive dashboards and reports for data-driven decisions'
    },
    {
      title: 'Data Visualization',
      description: 'Interactive charts, graphs, and visual analytics tools'
    },
    {
      title: 'Predictive Analytics',
      description: 'Forecast trends and predict future outcomes with ML models'
    },
    {
      title: 'Real-time Analytics',
      description: 'Live data processing and instant insights'
    },
    {
      title: 'Big Data Processing',
      description: 'Handle massive datasets with distributed computing'
    },
    {
      title: 'Custom Reporting',
      description: 'Automated reports tailored to your business needs'
    }
  ];

  const benefits = [
    {
      title: 'Data-Driven Decisions',
      description: 'Make informed choices backed by solid analytics'
    },
    {
      title: 'Improved Efficiency',
      description: 'Identify bottlenecks and optimize operations'
    },
    {
      title: 'Competitive Advantage',
      description: 'Stay ahead with actionable market insights'
    },
    {
      title: 'ROI Tracking',
      description: 'Measure and maximize return on investment'
    }
  ];

  const pricing = [
    {
      id: 1,
      name: 'Analytics Basic',
      price: '$3,000',
      period: 'project',
      description: 'Essential analytics setup',
      features: [
        'Dashboard creation',
        'Basic data visualization',
        'Standard reports',
        'Data integration (2 sources)',
        '1 month support'
      ]
    },
    {
      id: 2,
      name: 'Analytics Pro',
      price: '$8,000',
      period: 'project',
      popular: true,
      description: 'Advanced analytics platform',
      features: [
        'Custom dashboards',
        'Advanced visualizations',
        'Predictive analytics',
        'Multiple data sources',
        'Real-time monitoring',
        '3 months support'
      ]
    },
    {
      id: 3,
      name: 'Analytics Enterprise',
      price: 'Custom',
      description: 'Full-scale data infrastructure',
      features: [
        'Enterprise BI platform',
        'Big data processing',
        'Advanced ML models',
        'Unlimited data sources',
        'Custom integrations',
        'Dedicated analyst',
        '12 months support'
      ]
    }
  ];

  return (
    <ServicePageTemplate
      title="Data Analytics"
      subtitle="Advanced Data Analytics"
      description="Transform raw data into actionable insights with our comprehensive analytics solutions. Make smarter decisions backed by powerful data visualization and business intelligence."
      icon={BarChart}
      features={features}
      benefits={benefits}
      pricing={pricing}
      color="#88a2ff"
    />
  );
};

export default DataAnalytics;
